/** Badge colours the dashboard category chips use (a subset of the UI Badge `color` union). */
export type CategoryChipColor = 'primary' | 'warning' | 'secondary';

/** Keyword → colour, most-sensitive first (banking outranks the amber compliance group). */
const WARNING_KEYWORDS = ['tax', 'vat', 'bbbee', 'bee', 'coida', 'compliance'];

/**
 * Maps a (dynamic) supplier-update category name to a chip colour by sensitivity, matching the
 * prototype: banking = primary, tax/BEE/COIDA/compliance = warning (amber), everything else =
 * secondary. Case-insensitive and keyword-based so it tolerates the dynamic category names the
 * gateway returns (no fixed enum); an unknown/empty name is neutral.
 */
export const categoryChipColor = (categoryName: string): CategoryChipColor => {
  const name = (categoryName ?? '').toLowerCase();
  if (name.includes('bank')) {
    return 'primary';
  }
  if (WARNING_KEYWORDS.some((keyword) => name.includes(keyword))) {
    return 'warning';
  }
  return 'secondary';
};
